import { NgModule } from '@angular/core';
import { ScullyContentComponent } from './scully-content.component';

@NgModule({
  declarations: [ScullyContentComponent],
  exports: [ScullyContentComponent]
})
export class ScullyContentModule {}
